import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { 
  checkmarkCircle, 
  alertCircle, 
  informationCircle, 
  warningOutline, 
  closeOutline 
} from 'ionicons/icons';

export interface ToastData {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  showCloseButton?: boolean;
}

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon]
})
export class CustomToastComponent implements OnInit {
  @Input() toast!: ToastData;
  @Output() dismiss = new EventEmitter<string>();

  isVisible = false;

  constructor() {
    addIcons({
      checkmarkCircle,
      alertCircle,
      informationCircle,
      warningOutline,
      closeOutline
    });
  }

  ngOnInit() {
    // Trigger animation
    setTimeout(() => {
      this.isVisible = true;
    }, 10);

    // Auto dismiss if duration is set
    if (this.toast.duration && this.toast.duration > 0) {
      setTimeout(() => {
        this.dismissToast();
      }, this.toast.duration);
    }
  }

  dismissToast() {
    this.isVisible = false;
    // Wait for animation to complete before emitting dismiss
    setTimeout(() => {
      this.dismiss.emit(this.toast.id);
    }, 300);
  }

  getIcon(): string {
    switch (this.toast.type) {
      case 'success': return 'checkmark-circle';
      case 'error': return 'alert-circle';
      case 'warning': return 'warning-outline';
      case 'info': return 'information-circle';
      default: return 'information-circle';
    }
  }

  getTypeClass(): string {
    return `toast-${this.toast.type}`;
  }
} 